import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface RibaModalData {
  amount_to_be_raised: string;
  progressbar_percent: number;
  amount_received: string;
  number_of_investors: number;
}

@Injectable({
  providedIn: 'root'
})
export class RibaModalService {
  private isModalOpenSubject = new BehaviorSubject<boolean>(false);
  private modalDataSubject = new BehaviorSubject<RibaModalData>({
    amount_to_be_raised: '$ 2M',
    progressbar_percent: 60,
    amount_received: '$976,890',
    number_of_investors: 120
  });

  public isModalOpen$: Observable<boolean> = this.isModalOpenSubject.asObservable();
  public modalData$: Observable<RibaModalData> = this.modalDataSubject.asObservable();

  constructor() {}

  openModal(): void {
    this.isModalOpenSubject.next(true);
  }

  closeModal(): void {
    this.isModalOpenSubject.next(false);
  }

  updateModalData(data: Partial<RibaModalData>): void {
    const currentData = this.modalDataSubject.value;
    this.modalDataSubject.next({ ...currentData, ...data });
  }

  get isModalOpen(): boolean {
    return this.isModalOpenSubject.value;
  }

  get modalData(): RibaModalData {
    return this.modalDataSubject.value;
  }
}
